import React, { memo, Fragment } from 'react';
import { LatexComponent } from '../..';

import { TestDetailQuizModel } from 'models/test-detail.model';
import './index.css';
interface PropTypes {
    question: TestDetailQuizModel;
    showTruth: boolean;
}
const TCHNhieuTrinhDonThaXuongComponent: React.FC<PropTypes> = ({ question, showTruth }) => {
  return (
    <div>
      {(question.multiplePositionAnswer || []).map((posAnswer, index) => {
        const childAnswers = Array.isArray(posAnswer.childQuestionAnswers)
          ? posAnswer.childQuestionAnswers
          : [];

        const correctAnswers = childAnswers.filter(a => a.isCorrect);
        const incorrectAnswers = childAnswers.filter(a => !a.isCorrect);
        const correctAnswerText = correctAnswers.map(a => a.answer).join(', ');

        let selectedOrder = -1;
        if (question.userAnswer?.length) {
          selectedOrder = +question.userAnswer[index];
        }

        // Kiểm tra đúng hay sai
        const isCorrect = correctAnswers.map(a => a.order).includes(selectedOrder);

        // Lấy comment gợi ý
        let comment = correctAnswers.map(a => a.comment).join(', ');
        if (!isCorrect) {
          comment = incorrectAnswers.map(a => a.comment).join(', ');
        }

        return (
          <Fragment key={`answer${question.id}-${index}`}>
            <div className="dien_vao_nhieu_khoang_trong" />
            <div className="grid">
              <div className="col-12">
                Vị trí:{' '}
                <b>
                  {posAnswer.answer}{" "}
                </b>
                trả lời{" "}
                {isCorrect ? (
                  <span className="text-green-400 text-bold">Đúng</span>
                ) : (
                  <span className="text-red-400 text-bold">Sai</span>
                )}
              </div>

              {!isCorrect && showTruth && (
                <div className="col-12">
                  <LatexComponent>
                    <>
                      <span>
                        <i className="pi pi-check-square text-green-400 text-bold mr-2 font-size-14" />
                        Đáp án đúng:
                      </span>
                      <span
                        className="ml-1"
                        dangerouslySetInnerHTML={{ __html: correctAnswerText }}
                      />
                    </>
                  </LatexComponent>
                </div>
              )}

              {comment && (
                <div className="col-12">
                  <small>
                    <LatexComponent>
                      <>
                        - Gợi ý:{' '}
                        <b>
                          <span
                            className="ml-1"
                            dangerouslySetInnerHTML={{ __html: comment || '' }}
                          />
                        </b>
                      </>
                    </LatexComponent>
                  </small>
                </div>
              )}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

export default memo(TCHNhieuTrinhDonThaXuongComponent);
